// Redux
import { createSlice, PayloadAction } from "@reduxjs/toolkit";

// Types
import type { RootState, ShowResultsSlice } from "redux/types";
import { ResultQuery } from "interfaces/searchPage/osaSearch";

// Constants
import { Sorting } from "constants/searchPage/gpoSearchEnum";

// Defaults
export const initialState: ShowResultsSlice = {
	sorting: Sorting.DATE,
	endedCourse: []
};

// Slice
export const showResultsSlice = createSlice({
	name: "SHOW_RESULTS",
	initialState,
	reducers: {
		setSorting: (state, action: PayloadAction<Sorting>) => {
			return { ...state, sorting: action.payload };
		},
		setEndedCourse: (state, action: PayloadAction<ResultQuery[]>) => {
			return { ...state, endedCourse: action.payload };
		}
	}
});

// Actions
export const { setSorting, setEndedCourse } = showResultsSlice.actions;

// Selector
export const sortingSelector = (state: RootState): Sorting => state.showResults.sorting;
export const endedCourseSelector = (state: RootState): ResultQuery[] => state.showResults.endedCourse;

// Reducers
export default showResultsSlice.reducer;
